import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const ExceptionListContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-start;
`;

export const ExceptionWrapper = styled.div``;

export const ExceptionList = styled.div`
  height: 100%;
  min-height: 435px;
  max-height: 435px;
  width: 100%;
  overflow-y: scroll;
  margin-top: 20px;

  &:nth-child(2), &:nth-child(3) {
    padding: 10px 15px;
  }
`;

export const ExcetionItemCategory = styled.p`
  padding: 10px;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.textPrimary};
  cursor: pointer;
  border-radius: 8px;
  background: ${prop => prop.active ? colors.white : 'transparent'};
`;

export const ExceptionListTitle = styled.p`
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.textPrimary};
`;

export const ExceptionCheckboxContainer = styled.div`
  border-radius: 8px;
  padding: 17px;
  align-items: center;
  display: flex;
`;

export const ExceptionCheckboxField = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1.5px solid ${colors.textHyperlink};
  background: ${prop => prop.checked ? colors.textHyperlink : colors.white};
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ExceptionCheckboxLabel = styled.h6`
  color: ${colors.textPrimary};
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
`;

export const ExceptionSelectedItem = styled.p`
  display: grid;
  grid-template-columns: 1fr 22px;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  line-height: 22px;
  color: ${colors.textPrimary};
  padding: 25px 0;

  & + & {
    border-top: solid 1px ${colors.grayLight};
  }

  svg {
    width: 22px;
    height: 22px;
    cursor: pointer;
  }
`;    

export const ExceptionFormRow = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  row-gap: 20px;
`;
